// extracted by mini-css-extract-plugin
export default {"container":"header_container__f2Wsx","sebilogo":"header_sebilogo__1b+O+","azadilogo":"header_azadilogo__Axnfz"};